import { applyMiddleware, createStore } from "redux";
import createSagaMiddleware from "redux-saga";
import { createBrowserHistory } from "history";
import { composeWithDevTools } from "redux-devtools-extension";
import throttle from "lodash.throttle";

import { loadUser, initialState as authInitialState } from "authSetup";
import userManager from "user-manager";
import rootReducer from "../reducers";
import rootSaga from "../sagas/index";
import { saveState, loadState } from "./localStorage";

const persistedState = loadState();
let INITIAL_STATE = { ...authInitialState, ...persistedState };

export const history = createBrowserHistory();

const sagaMiddleware = createSagaMiddleware(rootSaga);

const store = createStore(
  rootReducer,
  INITIAL_STATE,
  composeWithDevTools(applyMiddleware(sagaMiddleware))
);

store.subscribe(
  throttle(() => {
    saveState({
      workListColumns: store.getState().workListColumns,
      user: {
        externalIds: []
      }
    });
  }, 1000)
);

sagaMiddleware.run(rootSaga);

loadUser(store, userManager);

export default store;
